<!-- Title for visitor -->
@if (isVisitor && mode === CraningBookingFormMode.NewReservation) {
    <h3 translate>services.craning.booking.form.titles.mine.new</h3>
}

<!-- Title for user -->
@if (!isVisitor && !craningBookingUtils.isExploitantView()) {
    @switch (mode) {
        @case (CraningBookingFormMode.NewReservation) {
            <h3 translate>services.craning.booking.form.titles.mine.new</h3>
        }
        @case (CraningBookingFormMode.UpdateReservation) {
            <h3 translate>services.craning.booking.form.titles.mine.update</h3>
        }
        @case (CraningBookingFormMode.DisplayReservation) {
            <h3>
                @if (selectedSlot?.state === CraningBookingSlotState.Paid) {
                    <span translate>services.craning.booking.form.titles.mine.paid</span>
                } @else {
                    <span translate>services.craning.booking.form.titles.mine.display</span>
                }
            </h3>
        }
    }
}

<!-- Title for exploitant -->
@if (craningBookingUtils.isExploitantView()) {
    @switch (mode) {
        @case (CraningBookingFormMode.NewReservation) {
            <h3 translate>services.craning.booking.form.titles.other.new</h3>
        }
        @case (CraningBookingFormMode.UpdateReservation) {
            <h3 translate>services.craning.booking.form.titles.other.update</h3>
        }
        @case (CraningBookingFormMode.DisplayReservation) {
            <h3>
                @if (selectedSlot?.state === CraningBookingSlotState.Paid) {
                    <span translate>services.craning.booking.form.titles.other.paid</span>
                } @else {
                    <span translate>services.craning.booking.form.titles.other.display</span>
                }
            </h3>
        }
        @case (CraningBookingFormMode.BillingReservation) {
            <h3 translate>services.craning.booking.form.titles.other.billing</h3>
        }
    }
}

@if (mode !== CraningBookingFormMode.Hidden) {
    <form [formGroup]="craningBookingForm">
        <!-- Selected Booking -->
        <div class="row">
            <fieldset class="col-12">
                <legend>
                    @if (!selectedSlot) {
                        <small class="text-danger" translate>services.craning.booking.form.selectedSlot.none</small>
                    } @else {
                        <small class="font-weight-bold"
                               [translateParams]="{
                            date: this.selectedSlot.date | date : formats.date,
                            startTime: DateUtils.formatTime(this.selectedSlot.startTime),
                            endTime: DateUtils.formatTime(this.selectedSlot.endTime)
                       }" translate>services.craning.booking.form.selectedSlot.date
                        </small>
                    }

                    @if (!!defaultSelectedSlot && selectedSlot !== defaultSelectedSlot && mode === CraningBookingFormMode.UpdateReservation) {
                        <small class="text-muted"
                               [translateParams]="{
                           date: this.defaultSelectedSlot.date | date : formats.date,
                           startTime: DateUtils.formatTime(this.defaultSelectedSlot.startTime),
                           endTime: DateUtils.formatTime(this.defaultSelectedSlot.endTime)
                       }" translate>services.craning.booking.form.selectedSlot.oldDate
                        </small>
                    }
                </legend>
            </fieldset>
        </div>

        <!-- User / Visitor chooser -->
        <div class="row mb-2">
            @if (!!debtorType && isCreationMode()) {
                <div class="col-12">
                    <label class="form-label">{{ 'services.craning.booking.form.debtorType' | translate }}*</label>
                    <div>
                        <div class="btn-group" role="group">
                            <input class="btn-check" type="radio"
                                   [formControl]="debtorType"
                                   [value]="debtorTypes.user">
                            <label class="btn btn-toggle btn-toggle-left h-auto"
                                   [ngClass]="{ active: debtorType.value === debtorTypes.user }"
                                   translate="services.craning.booking.form.debtorTypes.user"
                                   (click)="debtorType.setValue(debtorTypes.user)"
                                   (keyup)="debtorType.setValue(debtorTypes.user)"></label>
                            <input class="btn-check" type="radio"
                                   [formControl]="debtorType"
                                   [value]="debtorTypes.visitor">
                            <label class="btn btn-toggle btn-toggle-right h-auto"
                                   [ngClass]="{ active: debtorType.value === debtorTypes.visitor }"
                                   translate="services.craning.booking.form.debtorTypes.visitor"
                                   (click)="debtorType.setValue(debtorTypes.visitor)"
                                   (keyup)="debtorType.setValue(debtorTypes.visitor)"></label>
                        </div>
                    </div>

                    <app-form-error [control]="debtorType"></app-form-error>
                </div>
            }
        </div>

        <!-- User Search field -->
        @if (!!selectCustomer && isCreationMode()) {
            <div class="row">
                <div class="col-12">
                    <app-search-customer #searchCustomerComponent formControlName="searchCustomerComponent"
                                     (selectedCustomerEvent)="setSearchedCustomer($event)"
                                     [customerContact]="customerContact"
                                     ngDefaultControl></app-search-customer>
                    <app-form-error [control]="searchCustomerComponent"></app-form-error>
                </div>
            </div>
        }

        <!-- Boat Select field -->
        @if (!!selectCustomerBoat && !isDisplayMode() && !isBillingMode()) {
            <div class="row">
                <div class="col-12">
                    <label class="form-label"
                           for="selectCustomerBoat">{{ 'services.craning.booking.form.selectBoat' | translate }}
                        *</label>
                    <select class="form-control form-select" id="selectCustomerBoat" formControlName="selectCustomerBoat">
                        @for (boat of mooringPlaceBoats; track boat) {
                            <option
                                [ngValue]="boat"
                                [selected]="selectCustomerBoat.value === boat">{{ craningBookingUtils.getBoatLabel(boat) }}
                            </option>
                        }
                    </select>
                    <app-form-error [control]="selectCustomerBoat"></app-form-error>
                </div>
            </div>
        }

        <!-- User/Visitor summary -->
        @if (!!customerContact) {
            <div class="row mt-4">
                <fieldset class="col-12">
                    <legend
                        [translate]="!craningBookingUtils.isExploitantView() ? 'services.craning.booking.form.debtor.mine' : 'services.craning.booking.form.debtor.other'"></legend>
                    <div class="col-sm-6">
                        <table class="table table-borderless no-padding"
                               [attr.aria-label]="(!craningBookingUtils.isExploitantView() ? 'services.craning.booking.form.debtor.mine' : 'services.craning.booking.form.debtor.other') | translate"
                               aria-hidden="true">
                            <tbody>
                            <tr>
                                <td translate>services.craning.booking.form.debtor.name</td>
                                <td>{{ this.customerContact.firstName }} {{ this.customerContact.lastName }}</td>
                            </tr>
                            <tr>
                                <td translate>bookings.modal.user.street</td>
                                <td>{{ this.customerContact.street }}</td>
                            </tr>
                            <tr>
                                <td translate>bookings.modal.user.city</td>
                                <td>{{ this.customerContact.postalCode }} {{ this.customerContact.city }}</td>
                            </tr>
                            <tr>
                                <td translate>bookings.modal.user.country</td>
                                <td>{{ this.customerContact.country }}</td>
                            </tr>
                            <tr>
                                <td translate>bookings.modal.user.email</td>
                                <td>{{ this.customerContact.email }}</td>
                            </tr>
                            <tr>
                                <td translate>bookings.modal.user.phoneNumber</td>
                                <td>{{ this.customerContact.phone }}</td>
                            </tr>
                                @if (visitorBoatFormGroup?.disabled && mooringPlaceBoats.length === 0) {
                                    <tr>
                                        <td class="text-warning" colspan="2" translate>
                                            services.craning.booking.form.warnings.customerWithoutBoat
                                        </td>
                                    </tr>
                                }

                                @if (!!selectedMooringPlaceBoat) {
                                    <tr>
                                        <td class="pt-2"><strong
                                            translate>services.craning.booking.form.boatTitle</strong></td>
                                    </tr>
                                    <tr>
                                        <td translate>mooringPlace.modal.boatRegistrationNumber</td>
                                        <td>{{ craningBookingUtils.getBoatLabel(selectedMooringPlaceBoat) }}</td>
                                    </tr>
                                    <tr>
                                        <td translate>mooringPlace.modal.boatWeight</td>
                                        <td> {{ selectedMooringPlaceBoat.boatWeightInKg | numberFormat: GesConstants.defaultNumeralFormat }}
                                            kg
                                        </td>
                                    </tr>
                                    <tr>
                                        <td translate>services.craning.booking.form.boatDimensions</td>
                                        <td>{{ selectedMooringPlaceBoat.boatWidthInMeter | numberFormat: GesConstants.defaultNumeralFormat }}
                                            m
                                            x {{ selectedMooringPlaceBoat.boatLengthInMeter | numberFormat: GesConstants.defaultNumeralFormat }}
                                            m
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>

                    @if (craningBookingUtils.isExploitantView() && !!selectedMooringPlaceBoat && (selectedSlot === null || selectedSlot?.state !== CraningBookingSlotState.Paid)) {
                        <div class="btn-bar">
                            <button class="btn btn-primary" (click)="editMooringPlace()" translate>
                                services.craning.booking.form.editBoat
                            </button>
                        </div>
                    }
                </fieldset>
            </div>
        }

        <!-- Visitor Form -->
        @if (!!visitorInfoFormGroup) {
            <div class="row mt-4">
                <fieldset class="col-12" [formGroupName]="enableableFormControlNames.visitorInfo">
                    <legend translate="services.craning.booking.form.debtor.visitor"></legend>
                    <div class="row">
                        <!-- firstname -->
                        <div class="col-sm-6">
                            <label class="form-label" for="visitorFirstname">
                                {{ 'bookings.modal.user.firstname' | translate }}*
                            </label>
                            @if (!isDisplayMode()) {
                                <input class="form-control" id="visitorFirstname" name="visitorFirstname"
                                       formControlName="firstname"
                                       pattern="{{FormUtils.textInputPattern}}" type="text"
                                       placeholder="{{'bookings.modal.user.firstname' | translate}}" maxlength="50">

                                <app-form-error [control]="visitorFirstname"></app-form-error>
                            } @else {
                                <ng-container class="col-12">
                                    <span class="form-control">{{ this.visitorFirstname.value }}</span>
                                </ng-container>
                            }
                        </div>

                        <!-- lastname -->
                        <div class="col-sm-6">
                            <label class="form-label" for="visitorLastname">
                                {{ 'bookings.modal.user.lastname' | translate }}*
                            </label>

                            @if (!isDisplayMode()) {
                                <input class="form-control" id="visitorLastname" name="visitorLastname"
                                       formControlName="lastname"
                                       pattern="{{FormUtils.textInputPattern}}" type="text"
                                       placeholder="{{'bookings.modal.user.lastname' | translate}}" maxlength="50">
                                <app-form-error [control]="visitorLastname"></app-form-error>
                            } @else {
                                <span class="form-control">{{ this.visitorLastname.value }}</span>
                            }
                        </div>
                    </div>

                    <div class="row">
                        <!-- email -->
                        <div class="col-sm-6">
                            <label class="form-label" for="visitorEmail">
                                {{ 'bookings.modal.user.email' | translate }}*
                            </label>

                            @if (!isDisplayMode()) {
                                <input class="form-control" id="visitorEmail" name="visitorEmail"
                                       formControlName="email"
                                       pattern="{{FormUtils.textInputPattern}}" type="text"
                                       placeholder="{{'bookings.modal.user.email' | translate}}" maxlength="75">
                                <app-form-error [control]="visitorEmail"></app-form-error>
                            } @else {
                                <ng-container class="col-12">
                                    <span class="form-control">{{ this.visitorEmail.value }}</span>
                                </ng-container>
                            }
                        </div>

                        <!-- Phone -->
                        <div class="col-sm-6">
                            <label class="form-label" for="visitorPhoneNumber">
                                {{ 'bookings.modal.user.phoneNumber' | translate }}*
                            </label>
                            @if (!isDisplayMode()) {
                                <input class="form-control" id="visitorPhoneNumber" name="visitorPhoneNumber"
                                       formControlName="phoneNumber"
                                       pattern="{{FormUtils.textInputPattern}}" type="tel"
                                       placeholder="{{ 'common.placeholders.phone' | translate}}" maxlength="16">

                                <app-form-error [control]="visitorPhoneNumber"></app-form-error>
                            } @else {
                                <span class="form-control">{{ this.visitorPhoneNumber.value }}</span>
                            }
                        </div>
                    </div>

                    <div class="row">
                        <!-- street -->
                        <div class="col-sm-6">
                            <label class="form-label" for="visitorStreet">
                                {{ 'users.form.street' | translate }}*
                            </label>

                            @if (!isDisplayMode()) {
                                <input class="form-control" id="visitorStreet" name="visitorStreet"
                                       formControlName="street"
                                       pattern="{{FormUtils.textInputPattern}}" type="text"
                                       placeholder="{{'users.form.street' | translate}}" maxlength="50">

                                <app-form-error [control]="visitorStreet"></app-form-error>
                            } @else {
                                <ng-container class="col-12">
                                    <span class="form-control">{{ this.visitorStreet.value }}</span>
                                </ng-container>
                            }
                        </div>

                        <!-- postal code -->
                        <div class="col-sm-6">
                            <label class="form-label" for="visitorPostalCode">
                                {{ 'users.form.postalCode' | translate }}*
                            </label>

                            @if (!isDisplayMode()) {
                                <input class="form-control" id="visitorPostalCode" name="visitorPostalCode"
                                       formControlName="postalCode"
                                       pattern="{{FormUtils.textInputPattern}}" type="text"
                                       placeholder="{{'users.form.postalCode' | translate}}" maxlength="10">
                                <app-form-error [control]="visitorPostalCode"></app-form-error>
                            } @else {
                                <span class="form-control">{{ this.visitorPostalCode.value }}</span>
                            }
                        </div>
                    </div>

                    <div class="row">
                        <!-- city -->
                        <div class="col-sm-6">
                            <label class="form-label" for="visitorCity">
                                {{ 'users.form.city' | translate }}*
                            </label>

                            @if (!isDisplayMode()) {
                                <input class="form-control" id="visitorCity" name="visitorCity" formControlName="city"
                                       pattern="{{FormUtils.textInputPattern}}" type="text"
                                       placeholder="{{'users.form.city' | translate}}" maxlength="25">
                                <app-form-error [control]="visitorCity"></app-form-error>
                            } @else {
                                <span class="form-control">{{ this.visitorCity.value }}</span>
                            }
                        </div>

                        <!-- country -->
                        <div class="col-sm-6">
                            <label class="form-label" for="visitorCountry">
                                {{ 'users.form.country' | translate }}*
                            </label>

                            @if (!isDisplayMode()) {
                                <input class="form-control" id="visitorCountry" name="visitorCountry"
                                       formControlName="country"
                                       pattern="{{FormUtils.textInputPattern}}" type="text"
                                       placeholder="{{'users.form.country' | translate}}" maxlength="25">
                                <app-form-error [control]="visitorCountry"></app-form-error>
                            } @else {
                                <span class="form-control">{{ this.visitorCountry.value }}</span>
                            }
                        </div>
                    </div>
                </fieldset>
            </div>
        }

        <!-- Boat Form-->
        @if (!!visitorBoatFormGroup) {
            <div class="row mt-4">
                <fieldset class="col-12" [formGroupName]="enableableFormControlNames.visitorBoat">
                    <legend translate="mooringPlace.modal.boatInformationTitle"></legend>
                    <div class="row">
                        <!-- registration number -->
                        <div class="col-sm-6">
                            <label class="form-label" for="boatRegistrationNumber">
                                {{ 'mooringPlace.modal.boatRegistrationNumber' | translate }}*
                            </label>

                            @if (!isDisplayMode()) {
                                <input class="form-control" id="boatRegistrationNumber" name="boatRegistrationNumber"
                                       formControlName="registrationNumber"
                                       pattern="{{FormUtils.textInputPattern}}" type="text"
                                       placeholder="{{'mooringPlace.modal.boatRegistrationNumber' | translate}}"
                                       maxlength="50"
                                       required>
                                <app-form-error [control]="visitorBoatRegistrationNumber"></app-form-error>
                            } @else {
                                <span class="form-control">{{ this.visitorBoatRegistrationNumber.value }}</span>
                            }
                        </div>

                        <!-- boat weight -->
                        <div class="col-sm-6">
                            <label class="form-label" for="boatWeight">
                                {{ 'mooringPlace.modal.boatWeight' | translate }}*
                            </label>
                            @if (!isDisplayMode()) {
                                <input class="form-control" id="boatWeight" name="boatWeight"
                                       formControlName="weightInKg"
                                       pattern="{{FormUtils.textInputPattern}}" type="number"
                                       placeholder="{{'mooringPlace.modal.boatWeight' | translate}}"
                                       (keydown)="FormUtils.validateInputNumberLength($event, 10)">
                                <app-form-error [control]="visitorBoatWeightInKg"></app-form-error>
                            } @else {
                                <span class="form-control">{{ this.visitorBoatWeightInKg.value }}</span>
                            }
                        </div>
                    </div>

                    <div class="row">
                        <!-- boat width -->
                        <div class="col-sm-6">
                            <label class="form-label" for="boatWidth">
                                {{ 'mooringPlace.modal.boatWidth' | translate }}*
                            </label>

                            @if (!isDisplayMode()) {
                                <input class="form-control" id="boatWidth" name="boatWidth"
                                       formControlName="widthInMeter"
                                       pattern="{{FormUtils.textInputPattern}}" type="number" step="0.01"
                                       placeholder="{{'mooringPlace.modal.boatWidth' | translate}}"
                                       (keydown)="FormUtils.validateInputNumberLength($event, 10)">
                                <app-form-error [control]="visitorBoatWidthInMeter"></app-form-error>
                            } @else {
                                <span class="form-control">{{ this.visitorBoatWidthInMeter.value }}</span>
                            }
                        </div>

                        <!-- boat length -->
                        <div class="col-sm-6">
                            <label class="form-label" for="boatLength">
                                {{ 'mooringPlace.modal.boatlength' | translate }}*
                            </label>

                            @if (!isDisplayMode()) {
                                <input class="form-control" id="boatLength" name="boatLength"
                                       formControlName="lengthInMeter"
                                       pattern="{{FormUtils.textInputPattern}}" type="number" step="0.01"
                                       placeholder="{{'mooringPlace.modal.boatlength' | translate}}"
                                       (keydown)="FormUtils.validateInputNumberLength($event, 10)">
                                <app-form-error [control]="visitorBoatLengthInMeter"></app-form-error>
                            } @else {
                                <span class="form-control">{{ this.visitorBoatLengthInMeter.value }}</span>
                            }
                        </div>
                    </div>
                </fieldset>
            </div>
        }

        <!-- Services Form -->
        @if (selectedSlot?.state !== CraningBookingSlotState.Paid) {
            <div class="row mt-4">
                <fieldset class="col-12">
                    <legend>
                        {{ 'services.craning.booking.form.services' | translate }}

                        <span class="small">
                            ({{ 'services.craning.booking.form.servicesInfo' | translate }})
                        </span>
                    </legend>

                    <div class="table-responsive">
                        <table class="table table-striped"
                               [attr.aria-label]="'services.craning.booking.form.services' | translate">
                            <thead>
                            <tr>
                                <th scope="col" style="min-width: 85%" translate>services.craning.booking.form.service
                                </th>
                                <th scope="col" style="width: 150px" class="text-center" translate>
                                    services.craning.booking.form.serviceChoice
                                </th>
                                <th scope="col" style="width: 175px;" class="text-nowrap text-end" translate>
                                    services.craning.booking.form.price
                                </th>
                            </tr>
                            </thead>

                            <tbody>
                                @for (s of services.controls; track s; let i = $index) {
                                    <tr formArrayName="services">
                                        <td>
                                            <span class="service">
                                                {{ getCraningServiceLabel(craningServices[i]) }}
                                            </span>

                                            @if (getServicePricing(i) !== null && s.value === true) {
                                                <span class="pricing"
                                                      [ngClass]="{'text-warning': getServicePricing(i) === false}">
                                                    {{ getCraningServicePricingCategoryName(getServicePricing(i), i) }}
                                                </span>
                                            }
                                        </td>
                                        <td class="text-center">
                                            @if (!isDisplayMode()) {
                                                <input id="service-{{ i }}" type="checkbox" [formControlName]="i">
                                            } @else {
                                                <input type="checkbox" [disabled]="true" [checked]="s.value">
                                            }
                                        </td>
                                        <td class="text-end">
                                            @if (s.value === true) {
                                                <span>{{ getServicePrice(i) | currencyFormat }}</span>
                                            }
                                            @if (!s.value || getServicePricing(i) === false) {
                                                <span>{{ '-.-- CHF' }}</span>
                                            }
                                        </td>
                                    </tr>
                                }

                            <!-- Miscellaneous Billing Item -->
                                @if (isBillingMode()) {
                                    <tr>
                                        <td>
                                            <div class="input-group m-0">
                                                <span class="justify-content-center align-self-center pe-2">
                                                    {{ 'services.craning.booking.form.miscellaneousServiceLabel' | translate }}
                                                    &#58;
                                                </span>
                                                <textarea class="form-control border"
                                                          [formControl]="miscellaneousServiceLabel"
                                                          placeholder="{{ 'services.craning.booking.form.miscellaneousServicePlaceholder' | translate }}"
                                                          rows="1"
                                                          maxlength="255"></textarea>
                                            </div>

                                            <app-form-error [control]="miscellaneousServiceForm"></app-form-error>

                                            @if (!craningBookingForm.pristine && !miscellaneousServiceForm.pristine) {
                                                <p class="text-warning my-1"
                                                   translate="services.craning.booking.form.miscellaneousServiceWontBeSavedMessageWarning"></p>
                                            }
                                        </td>

                                        <td class="text-center"></td>

                                        <td class="text-end">
                                            <div class="btn-bar m-0">
                                                <input class="form-control border" type="number"
                                                       [formControl]="miscellaneousServiceAmount">
                                                <span class="justify-content-center align-self-center">CHF</span>
                                            </div>

                                            <app-form-error [control]="miscellaneousServiceAmount"></app-form-error>
                                        </td>
                                    </tr>
                                }
                            </tbody>

                            <tfoot>
                            <tr>
                                <td translate>services.craning.booking.form.footer.bookingTotalPrice</td>
                                <td></td>
                                <td [ngClass]="{
                                        'text-end': true,
                                        'text-warning': getTotalPrice().hasMissingValue
                                    }">
                                    {{ getTotalPrice().price | currencyFormat }}
                                </td>
                            </tr>

                                @if (!selectedBooking?.id) {
                                    <tr>
                                        <td translate>services.craning.booking.form.footer.bookingDepositPrice</td>
                                        <td></td>
                                        <td class="text-end">{{ getDepositPrice() | currencyFormat }}</td>
                                    </tr>
                                } @else {
                                    <tr>
                                        <td translate>services.craning.booking.form.footer.billingDepositPrice</td>
                                        <td></td>
                                        <td class="text-end">{{ (getDepositPrice() * -1) | currencyFormat }}</td>
                                    </tr>

                                    <tr>
                                        <td translate>services.craning.booking.form.footer.billingBalanceDue</td>
                                        <td></td>
                                        <td class="text-end">{{ getBillingBalanceDue() | currencyFormat }}</td>
                                    </tr>
                                }
                            </tfoot>
                        </table>
                    </div>
                </fieldset>
            </div>
        }

        <!-- Bill details -->
        @if (selectedSlot?.state === CraningBookingSlotState.Paid) {
            <div class="row mt-4">
                <app-craning-booking-form-bill-details-component [crtLang]="crtLang" [slotId]="selectedSlot.id"
                    [serviceId]="service.serviceId" [isExploitantView]="craningBookingUtils.isExploitantView()">
                </app-craning-booking-form-bill-details-component>
            </div>
        }

        <!-- Questions Form -->
        @if (!isBillingMode() && selectedSlot?.state !== CraningBookingSlotState.Paid) {
            <div class="row mt-4">
                <fieldset class="col-12 questions">
                    <legend>{{ 'services.craning.booking.form.questions' | translate }} <span
                        class="small">({{ 'services.craning.booking.form.questionsInfo' | translate }})</span></legend>
                    @if (!hasActiveQuestions()) {
                        <div>-</div>
                    } @else {
                        <ng-container formArrayName="questions">
                            @for (s of services.controls; track s; let craningServiceIndex = $index) {
                                @if (getServiceQuestionsForServiceFormArray(craningServiceIndex).controls.length > 0
                                && services.get(craningServiceIndex.toString()).value) {
                                    <div class="row" formArrayName="{{ craningServiceIndex }}">
                                        <div class="col-12">
                                            <strong>{{ getCraningServiceLabel(craningServices[craningServiceIndex]) }}</strong>
                                        </div>
                                        @for (
                                            q of getServiceQuestionsForServiceFormArray(craningServiceIndex).controls; track q; let
                                            questionIndex = $index) {
                                            <div class="col-12 col-sm-6">
                                                <label class="form-label"
                                                       for="{{ 'question-' + craningServiceIndex + '-' + questionIndex }}">
                                                    {{ getCraningServiceQuestionLabel(craningServices[craningServiceIndex].questions[questionIndex]) }}
                                                </label>
                                                <div>
                                                    @if (craningServices[craningServiceIndex].questions[questionIndex].answerType === CraningServiceAnswerType.Boolean) {
                                                        <div class="btn-group" role="group"
                                                        >
                                                            <input class="btn-check" type="radio"
                                                                   formControlName="{{ questionIndex }}"
                                                                   [value]="false"
                                                                   [attr.disabled]="isDisplayMode() ? '' : null">
                                                            <label class="btn btn-toggle btn-toggle-left h-auto"
                                                                   [ngClass]="{ active: q.value }"
                                                                   translate="common.yes"
                                                                   (click)="q.setValue(true); q.markAsDirty();"
                                                                   (keyup)="q.setValue(true); q.markAsDirty();"></label>
                                                            <input class="btn-check" type="radio"
                                                                   formControlName="{{ questionIndex }}"
                                                                   [value]="true"
                                                                   [attr.disabled]="isDisplayMode() ? '' : null">
                                                            <label class="btn btn-toggle btn-toggle-right h-auto"
                                                                   [ngClass]="{ active: q.value === false }"
                                                                   translate="common.no"
                                                                   (click)="q.setValue(false); q.markAsDirty();"
                                                                   (keyup)="q.setValue(false); q.markAsDirty();"></label>
                                                        </div>
                                                    }

                                                    @if (craningServices[craningServiceIndex].questions[questionIndex].answerType === CraningServiceAnswerType.Number && !isDisplayMode()) {
                                                        <input
                                                            class="form-control"
                                                            id="{{ 'question-' + craningServiceIndex + '-' + questionIndex }}"
                                                            formControlName="{{ questionIndex }}"
                                                            pattern="{{FormUtils.textInputPattern}}" type="number"
                                                            step="1"
                                                            placeholder="{{ getCraningServiceQuestionLabel(craningServices[craningServiceIndex].questions[questionIndex]) }}"
                                                            (keydown)="FormUtils.validateInputNumberLength($event, 10)">
                                                    }

                                                    @if (craningServices[craningServiceIndex].questions[questionIndex].answerType === CraningServiceAnswerType.Text && !isDisplayMode()) {
                                                        <input
                                                            class="form-control"
                                                            id="{{ 'question-' + craningServiceIndex + '-' + questionIndex }}"
                                                            formControlName="{{ questionIndex }}"
                                                            placeholder="{{ getCraningServiceQuestionLabel(craningServices[craningServiceIndex].questions[questionIndex]) }}"
                                                            pattern="{{ FormUtils.textInputPattern }}" type="text"
                                                            maxlength="50">
                                                    }

                                                    @if (craningServices[craningServiceIndex].questions[questionIndex].answerType !== CraningServiceAnswerType.Boolean && isDisplayMode()) {
                                                        <span class="form-control">{{ q.value }}</span>
                                                    }

                                                    <app-form-error
                                                        [control]="questions.get(craningServiceIndex.toString()).get(questionIndex.toString())"></app-form-error>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                            }
                        </ng-container>
                    }
                </fieldset>
            </div>
        }

        <!-- Payment Form-->
        @if (!!paymentTypeFormGroup && availablePaymentTypes.length > 1) {
            <div class="row mt-4">
                <fieldset class="col-12" [formGroupName]="enableableFormControlNames.paymentType">
                    <legend translate>services.craning.booking.form.billing.title</legend>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="col-12">
                                <app-payment-type-chooser [availablePaymentTypes]="availablePaymentTypes"
                                                          (selectedPaymentType)="selectPaymentType($event)"></app-payment-type-chooser>
                                <app-form-error [control]="paymentType"></app-form-error>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        }

        <!-- Action Buttons -->
        <div class="btn-bar">
            @if (!craningBookingForm.pristine && !isCreationMode()) {
                <button type="submit" class="btn btn-outline-secondary"
                        (click)="populateForm(selectedBooking)"
                        translate>common.cancelChanges
                </button>
            }

            @if (canSaveBooking()) {
                <button type="submit" class="btn btn-primary"
                        [disabled]="craningBookingForm.invalid || craningBookingForm.pristine"
                        (click)="openSaveBookingConfirmModal()"
                        translate>common.save
                </button>
            }

            @if (isBillingMode()) {
                <button type="submit" class="btn btn-primary"
                        [disabled]="craningBookingForm.invalid || !craningBookingForm.pristine || miscellaneousServiceForm.invalid"
                        (click)="billBooking()"
                        translate>common.bill
                </button>
            }
        </div>
    </form>
}
